import {Component, ViewContainerRef} from "@angular/core";
import {FUIAlertService} from "./alert.service";

@Component({
    selector: "fui-alerts",
    template: ""
})
export class FUIAlertsComponent {
    constructor(private alertService: FUIAlertService,
                private viewContainerRef: ViewContainerRef) {
        this.alertService.setPlaceholder(this.viewContainerRef);
    }
}
